const LANGUAGE_CODES = new Set(['en', 'fi', 'sv', 'de']);

export function isTranslationFailure(error: unknown): boolean {
  const message = String(
    (error as { data?: { message?: string }; message?: string })?.data
      ?.message ??
      (error as Error)?.message ??
      ''
  ).toLowerCase();
  return (
    message.includes('translation') ||
    message.includes('deepl') ||
    message.includes('quota')
  );
}

export function getTranslationWarningMessage(
  payload: { warning_message?: string } | undefined,
  fallbackMessage: string
): string | undefined {
  if (!payload?.warning_message) return undefined;
  return payload.warning_message || fallbackMessage;
}

export function ensureTranslationsForTextFields<T extends Record<string, unknown>>(
  translations: Record<string, T>,
  languageCodes: string[],
  sourceText: Record<string, string>,
  fields: string[]
): Record<string, T> {
  const result = { ...translations };
  for (const code of languageCodes) {
    const existing = result[code] ?? ({} as T);
    const filled = { ...existing } as Record<string, unknown>;
    let hasContent = false;
    for (const field of fields) {
      const value = filled[field];
      if (typeof value === 'string' && value.trim()) {
        hasContent = true;
      }
    }
    if (!hasContent) {
      for (const field of fields) {
        if (sourceText[field] !== undefined) {
          filled[field] = sourceText[field];
        }
      }
    }
    result[code] = filled as T;
  }
  return result;
}

export function stripNonLanguageKeys<T>(
  translations: Record<string, T>
): Record<string, T> {
  return Object.fromEntries(
    Object.entries(translations).filter(([key]) => LANGUAGE_CODES.has(key))
  ) as Record<string, T>;
}
